<template>
  <div>
    <div style="margin-bottom: 15px">
      <span>选择学校：</span>
      <a-select v-model="bizOrgId" :allowClear="true" style="width: 15%">
        <a-select-option v-for="bizOrg in bizOrgList" :value="bizOrg.id" :key="bizOrg.id">
          {{ bizOrg.name }}
        </a-select-option>
      </a-select>
      <span style="margin-left: 12px">姓名或手机号：</span>
      <a-input allow-clear v-model="keyword" style="width: 10%"/>
      <span style="margin-left: 12px">状态：</span>
      <a-select v-model="replyStatus" :allowClear="true" style="width: 10%">
        <a-select-option value="true" key="workerTake">
          已回复
        </a-select-option>
        <a-select-option value="false" key="workerPut">
          未回复
        </a-select-option>
      </a-select>
      <a-button type="primary" icon="search" style="margin-left: 15px" @click="handleSearch">查询</a-button>
    </div>
    <a-divider/>

    <a-table
        :columns="columns"
        :data-source="rows"
        :pagination="pagination"
        @change="handleTableChange"
        size="middle"
        :loading="loading"
        rowKey="id"
        bordered>
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="replyStatus" slot-scope="text, record">
        <span v-if="!record.replyStatus">
          <a-badge count="新" >
            <a-tag color="red">未回复</a-tag>
          </a-badge>
        </span>
        <span v-else>
          <a-tag color="green">已回复</a-tag>
        </span>
      </span>
      <template slot="action" slot-scope="text, record">
        <a-button style="padding: 0 3px;" type="link" @click="$refs.replyForm.showForm(record)">
          <a-icon type="edit"/>
          <span style="margin-left: 2px">回复</span>
        </a-button>
      </template>
    </a-table>
    <reply-form @reply="$emit('refreshNotification')" ref="replyForm" />
  </div>
</template>

<script>
import suggestService from '@/service/suggest'
import bizOrgService from '@/service/bizOrg'
import {trim} from "core-js/internals/string-trim";
import ReplyForm from "@/pages/Customer/ReplyForm";

export default {
  name: "OrderList",
  components: {ReplyForm},
  data() {
    return {
      columns: [
        {title: '#', scopedSlots: {customRender: 'serial'}, align: 'center'},
        {title: '学校', dataIndex: 'bizOrgName', align: 'center'},
        {title: '用户姓名', dataIndex: 'realName', align: 'center'},
        {title: '手机号', dataIndex: 'mobile', align: 'center'},
        {title: '班级', dataIndex: 'className', align: 'center'},
        {title: '性别', dataIndex: 'genderDesc', align: 'center'},
        {title: '反馈内容', dataIndex: 'content', align: 'center'},
        {title: '反馈时间', dataIndex: 'submitTime', align: 'center'},
        {title: '回复状态', dataIndex: 'replyStatus', scopedSlots: {customRender: 'replyStatus'}, align: 'center'},
        {title: '回复内容', dataIndex: 'reply', align: 'center', customRender: (text) => text?text: '-'},
        {title: '回复时间', dataIndex: 'replyTime', align: 'center', customRender: (text) => text?text: '-'},
        {title: '回复人', dataIndex: 'replyUserName', align: 'center', customRender: (text) => text?text: '-'},
        {title: '操作', width: "10%", dataIndex: 'action', scopedSlots: {customRender: 'action'}, align: 'center'}
      ],
      rows: [],
      pagination: {},

      keyword: '',
      bizOrgId: null,
      bizOrgList: [],
      replyStatus: null,
      loading: false,
    };
  },
  mounted() {
    let params = {
      current: 1,
      size: 10,
    }
    this.fetch(params)

    bizOrgService.queryBriefList().then((res) => {
      this.bizOrgList = res.data
    })
  },
  methods: {
    handleTableChange(pagination) {
      this.fetch(pagination)
    },
    handleSearch() {
      this.fetch()
    },
    fetch(page) {
      this.keyword = trim(this.keyword)
      let params = {
        current: page ? page.current : 1,
        size: page ? page.size : 10,
        keyword: this.keyword,
        bizOrgId: this.bizOrgId,
        replyStatus: this.replyStatus,
      }
      this.loading = true
      this.$emit('refreshNotification')
      suggestService.queryPage(params).then((res) => {
        const pagination = {...this.pagination};
        this.rows = res.data.records
        pagination.current = res.data.current
        pagination.total = res.data.total
        pagination.size = res.data.size + ''
        pagination.showTotal = (total, range) => {
          return `${range[0]}-${range[1]} 总计 ${total} 条`
        }
        this.pagination = pagination
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
  }
}
</script>
